@for (option of options(); track option.value) {
    <button (click)="toggle(option.value)"
            [attr.aria-pressed]="isActive(option.value)"
            [class.active]="isActive(option.value)"
            [class.person]="!!option.avatar"
            type="button">
        @if (option.avatar) {
            <app-avatar [name]="option.avatar.name" [seed]="option.avatar.seed ?? null" size="xs"></app-avatar>
        } @else if (option.color) {
            <span class="dot" [style.background]="option.color"></span>
        }
        {{ option.label }}
        @if (option.count !== undefined && option.count !== null) {
            <span class="count">{{ option.count }}</span>
        }
    </button>
}
